<template>
  <div class="card mb-0 shadow px-3">
    <div class="card-body px-0">
      <div class="tab-content">
        <div class="animate__animated animate__fadeIn">
          <div
            class="col-12 px-0"
            style="height: 600px; overflow-y: auto; overflow-x: hidden"
          >
            <Page titulo="Plano Individual de Atendimento - PIA" mode="table" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Page from "../../Show.vue";
export default {
  components: { Page },
  props: ["medida"],
};
</script>
<style scoped>
</style>
